//export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]{1,}\.[a-zA-Z0-9-]{2,}$/;
export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]{1,}\.([a-zA-Z]{2,})(\.[a-zA-Z]+)*/g;
export const numericalRegex = /^\d+(\.\d+)?$/;